import React from 'react'
import { useSelector } from 'react-redux'
import { PlainLink } from 'components/A'
import Tooltip from 'components/Tooltip'
import { getGeoLocation } from 'selectors/user/cookie'
import ProductsOriginalConnector, {
  ConnectorProps as ProductsOriginalProps,
} from '../../../connectors/ProductsOriginal'
import { ReasonsToBuyContainer, TooltipContent } from '../../styles/products'
import { InfoCircleIcon, CheckIcon } from '../../styles/icons'
import { ARTWORK, FOR_SALE } from '../../../helpers/constants'

import TrustPilot from './TrustPilot'

type Results = React.ReactElement<React.ComponentProps<any>, any> | null
export default ProductsOriginalConnector(
  (props: ProductsOriginalProps): Results => {
    const {
      isAple,
      productStatus,
      productType,
      dimensions: {
        height,
        width,
        depth,
      },
    } = props

    const { countryCode } = useSelector(getGeoLocation)

    if (productStatus !== FOR_SALE || productType !== ARTWORK) {
      return null
    }

    const longestSideInCentimeter = Math.max(height, width, depth)
    const isOversized = longestSideInCentimeter > 152 // 60 inches

    let title = '14-day satisfaction guarantee'
    let description = 'We offer a 14-day satisfaction guarantee on all works purchased through Saatchi Art, except for open and limited editions printed on-demand for you, as well as original photography, mixed media and printmaking.'
    let link = 'https://support.saatchiart.com/hc/en-us/articles/14673570463643'

    const currentMonth = new Date().getMonth() // 0-based index, June is 5
    const isJune = currentMonth === 5

    if (!isOversized && countryCode?.toLowerCase() === 'us' && isJune) {
      title = 'Only in June: FREE 14-Day Returns'
      description = 'For a limited time, U.S. customers can enjoy free returns within 14 days on original artworks purchased before 6/30. Try it in your space with confidence — if it’s not perfect, we’ll cover the standard restocking fee. Exclusions apply.'
      link = 'https://support.saatchiart.com/hc/en-us/articles/14673570463643-Return-Policy'
    }

    return (
      <ReasonsToBuyContainer>
        <div data-type='reason-to-buy-item-container'>
          <p className='defaultTypographySmall'>
            <CheckIcon /> Shipping included
          </p>
        </div>
        {!isAple && (
          <div data-type='reason-to-buy-item-container'>
            <p className='defaultTypographySmall'>
              <CheckIcon /> {title}
            </p>
            <div style={{ marginTop: '4px' }}>
              <Tooltip
                position='bottom'
                color='#333'
                tip={
                  <PlainLink
                    href={link}
                    target='_blank'
                    rel='noopener noreferrer'
                  >
                    <TooltipContent color='black' row>
                      <img
                        src='//d3t95n9c6zzriw.cloudfront.net/common/7-day-money-back.png'
                        width='75'
                        height='75'
                        nopin='nopin'
                      />
                      <span>
                        {description}
                      </span>
                    </TooltipContent>
                  </PlainLink>
                }
              >
                <InfoCircleIcon data-type='reason-to-buy' />
              </Tooltip>
            </div>
          </div>
        )}
        <div data-type='reason-to-buy-item-container'>
          <TrustPilot />
        </div>
      </ReasonsToBuyContainer>
    )
  }
)
